//酒店导航菜单
export default [
    {label:'订单管理',iconClass:'icon-dingdan1',powerArr:[139,261],path:{name:'OrderLists',query:{page:1,status:'today'}},num:'order'},
    {label:'人事管理',
        iconClass:'icon-renshiguanli',
        num:'unionRecord_count',
        powerArr:[],
        children:[
            {label:'销售列表',powerArr:[332,175,288,387,581],path:{name:'LinkedList'}},
            {label:'申请列表',powerArr:[337,170,293,392,582],path:{name:'PersonnelList'},num:'unionRecord_count'},
        ],
    },
    {label:'房态日历', iconClass:'icon-rili2', powerArr:[182,301,187,306,192,443,547], path:{name:'RoomCalendar',query:{step:'3'}}},
    {label:'资料信息',
        iconClass:'icon-Information',
        children:[
            {label:'企业资料',powerArr:[152,268,367,231,554,555],path:{name:'StoreBasicInfo'}},
            {label:'门店相册',powerArr:[152,268,367,231,554,555],path:{name:'StoreAlbum'}},
            // {label:'房型资料',powerArr:[182,301,187,306,192,443,547], path:{name:'GroupRoom',query:{step:'3'}}},
            // {label:'会场资料',powerArr:[182,301,187,306,192,443,547], path:{name:'GroupMeeting',query:{step:'4'}}},
            // {label:'认证信息',powerArr:[152,268,367,231,554,555],path:{name:'StoreCertification'}},
        ],
    },
    {label:'财务管理',
        iconClass:'icon-caiwuguanli',
                iconClass:'icon-Information',
        children:[
            // {label:'打款申请',powerArr:[152,268,367,231,554,555],path:{name:'PayApplyList'}},
            {label:'打款记录',powerArr:[152,268,367,231,554,555],path:{name:'FinancialList'}},
            // {label:'房型资料',powerArr:[182,301,187,306,192,443,547], path:{name:'GroupRoom',query:{step:'3'}}},
            // {label:'会场资料',powerArr:[182,301,187,306,192,443,547], path:{name:'GroupMeeting',query:{step:'4'}}},
            // {label:'认证信息',powerArr:[152,268,367,231,554,555],path:{name:'StoreCertification'}},
        ],
        // path:{name:'FinancialList'},
        // num:'treasurer_count'
    },
    {label:'认证信息',
        iconClass:'icon-qiyerenzheng2',
        children:[
            {label:'酒店资质',powerArr:[152,268,367,231,554,555],path:{name:'StoreCertification'},},
            {label:'银行卡管理',powerArr:[152,268,367,231,554,555],path:{name:'BankcardManage'}},
        ],
    },
    {label:'消息中心',iconClass:'icon-xiaoxi',powerArr:[],path:{name:'MsgLists',query:{msg_type:'2'}}},
    // {label:'排行榜',iconClass:'icon-icon-',powerArr:[],path:{name:'GradeManage'}},
    {label:'账号设置',iconClass:'icon-shezhi',powerArr:[],path:{name:'AccountSet'}}
]